import React from 'react';
import axios from 'axios';
import qs from 'qs';

import FatalErrorMessage from "./FatalErrorMessage";
import { getAirbrake } from '../../../helpers';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false, error: null };

    this.airbrake = getAirbrake();
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, info) {
    // Filter out non-relevant errors
    if (
      disableMobileLogging ||
      (error.response || error.request) || // axios error
      error.message?.includes('Cancel') ||
      error.message?.includes('Request aborted') ||
      error.message?.includes('Network Error') ||
      error.message?.includes('timeout of 0ms exceeded')
    ) {
      return;
    }

    if (this.airbrake) {
      this.airbrake.notify({
        error: error,
        params: {
          info: info,
        },
        context: {
          component: this.props.location ?? '',
        },
      });
    } else {
      try {
        axios
          .post(`${apiUrl}/reporterror`, qs.stringify({
            location: this.props.location ?? '',
            message: error.message ?? '',
            error: JSON.stringify(error),
            info,
          }))
          .catch((thrown) => {});
      } catch (err) {}
    }
  }

  render() {
    if (this.state.hasError) {
      return <FatalErrorMessage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
